export default "__VITE_ASSET__CCOTow04__"